/** Contratos do Behavior Rate Limiter (Etapa 20) — readonly, serializáveis. */

import type { BehaviorSignalType } from './signals';

/** Config normalizada do rate limiter. */
export type NormalizedRateLimitConfig = {
  readonly enabled: boolean;
  readonly windowMs: number;
  readonly maxSignalsPerWindow: number;
  readonly criticalBypass: boolean;
};

/** Decisão determinística por sinal. */
export type RateLimitDecision = 'accepted' | 'dropped' | 'bypassed';

/** Sinais críticos que nunca são descartados por default. */
export const CRITICAL_SIGNAL_TYPES: readonly BehaviorSignalType[] = [
  'IDLE',
  'ACTIVITY',
  'VISIBLE',
  'HIDDEN',
  'EXIT_INTENT',
];

/** Snapshot read-only para diagnostics. */
export type RateLimitSnapshot = {
  readonly enabled: boolean;
  readonly windowMs: number;
  readonly maxSignalsPerWindow: number;
  readonly criticalBypass: boolean;
  readonly accepted: number;
  readonly dropped: number;
  readonly bypassed: number;
  /** Sinais na janela corrente. */
  readonly windowCount: number;
  readonly windowStartedAt: number | undefined;
};
